var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer"},[_c('OMSelect',{attrs:{"options":_vm.langs,"cyId":"locale-selector"},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }